module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/cesu-rc-632a16525e23d54905c7f33ec45fbb2f.svg";